import { NativeModules } from 'react-native';

const { BlueStackPrivacy } = NativeModules;

export const BlueStackPrivacySettings = {
    setIsUserOptOut: (isUserOptOut: boolean) =>
        BlueStackPrivacy.setIsUserOptOut(isUserOptOut),
    setIsAgeRestrictedUser: (isAgeRestrictedUser: boolean) =>
        BlueStackPrivacy.setIsAgeRestrictedUser(isAgeRestrictedUser),
};
